import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { FilterPlainObject } from '../plainObjects/filter.plainObject';

export class FilterVisitor extends BaseTransformationVisitor {
    private get _filterTransformation(): FilterPlainObject {
        return this.transformation as FilterPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitTransformation(transformationContext: any): void {
        // Filter can have only only one expression, so getting first expression only.
        const expression = transformationContext.expression();
        if (expression[0]) {
            this._filterTransformation.conditionExpression = this._getText(transformationContext.expression(0));
        }
        if (expression[1]) {
            this.visit(expression[1]);
        }
    }
}
